
import api from "~api";
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
components: {
XHeader

},
data () {
return {
feeList: [],
info: {},
dorminfo: {
},
}
},
created(){
this.getReportData()
},
mounted() {

},
methods: {
userInfo(){

},
getReportData(){
var params = {
"stuCode": window.localStorage.getItem('stuCode'),
"year": new Date().getFullYear()+"",
"processId": this.$route.params.sort
}
api.post( '/payment/payCarry',params).then(res => {
if(res.status == 200){
this.info = res.data.results.student;
this.feeList = res.data.results.tuitions;
if(res.data.results.stuDorminfo!=null && res.data.results.stuDorminfo!={}){

this.feeList.push({
"name": "宿舍费",
"feeMoney": res.data.results.stuDorminfo.dormSum
});
}
if(this.info.gender=="1"){
this.$set(this.info,"sex","男")
}else{
this.$set(this.info,"sex","女")
}

}
}).catch( err =>{
this.$msgbox('温馨提示：',"系统错误，请刷新后再试！");
});
}

}
}



// WEBPACK FOOTER //
// ./src/components/registration.vue